import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const editRewardProduct = createAsyncThunk("editRewardProduct", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`product/${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardProductEditSlice = createSlice({
	name: "RewardProductEditSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(editRewardProduct.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(editRewardProduct.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(editRewardProduct.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default RewardProductEditSlice.reducer;
